import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {
	UntypedFormBuilder,
	UntypedFormControl,
	UntypedFormGroup,
	Validators,
	AbstractControl,
} from '@angular/forms';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { of } from 'rxjs';

@Component({
	selector: 'app-reset',
	templateUrl: './reset.component.html',
	styleUrls: ['./reset.component.scss'],
	standalone: false,
})
export class ResetComponent {
	RESET = {
		NEW_PASSWORD: 'newPassword',
		CONFIRM_PASSWORD: 'confirmPassword',
	};

	resetForm: UntypedFormGroup;
	email = 'johnsmith@email.com';
	showMatchError = false;
	matchErrorText = 'Passwords do not match';
	requiredErrorText = 'Password is required';
	requirementsErrorText = 'Password does not meet minumum requirements';

	strongPasswordRegex =
		/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;

	get newPassword(): AbstractControl {
		return this.reset[this.RESET.NEW_PASSWORD];
	}

	get confirmPassword(): AbstractControl {
		return this.reset[this.RESET.CONFIRM_PASSWORD];
	}

	get reset(): unknown {
		return this.resetForm.controls;
	}

	constructor(
		public router: Router,
		private formBuilder: UntypedFormBuilder,
		private routeService: NavigationService,
	) {
		this.resetForm = this.createNewResetForm();
	}

	private createNewResetForm = () =>
		this.formBuilder.group({
			[this.RESET.NEW_PASSWORD]: new UntypedFormControl('', [
				Validators.required,
			]),
			[this.RESET.CONFIRM_PASSWORD]: new UntypedFormControl('', [
				Validators.required,
			]),
		});

	passwordsMatch(c: UntypedFormGroup) {
		// to-do: show validation errors for passwords dont match
		if (c.value.newPassword !== c.value.confirmPassword) {
			this.showMatchError = true;
			this.resetForm.controls[this.RESET.CONFIRM_PASSWORD].setErrors({
				passwordsMatch: true,
			});

			return of({ passwordsMatch: true });
		}
		this.showMatchError = false;

		return null;
	}

	submit(): void {
		// to-do: show validation errors for required & requirements not met
		this.resetForm.setValidators(this.passwordsMatch.bind(this));
		this.resetForm.controls[this.RESET.NEW_PASSWORD].setValidators(
			Validators.pattern(this.strongPasswordRegex),
		);
		this.resetForm.controls[this.RESET.CONFIRM_PASSWORD].setValidators(
			Validators.pattern(this.strongPasswordRegex),
		);
		this.resetForm.markAllAsTouched();
		this.resetForm.updateValueAndValidity();
		if (this.resetForm.valid) {
			// to-do: add reset functionality
			this.routeService.goToLogin();
		}
	}
}
